export default __webpack_public_path__ + "static/mue-4c8a2049eb47e9974915dc76eea9d7ad.webp";